import { render, staticRenderFns } from "./NavCloth.vue?vue&type=template&id=ec0a7270&scoped=true"
import script from "./NavCloth.vue?vue&type=script&lang=js"
export * from "./NavCloth.vue?vue&type=script&lang=js"
import style0 from "./NavCloth.vue?vue&type=style&index=0&id=ec0a7270&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0a7270",
  null
  
)

export default component.exports